



























































































































































































import {Component, Vue, Watch} from "vue-property-decorator";

import Tab from "@/components/tab.vue";

import {
    queryCurrent,
    changeNickName,
    getUserProfile,
    updateUserProfile
} from "@/api/user/user";
import profile from "@/components/account/profile.vue";

const UserInfo = () => import("@/components/account/info.vue");
const UserProfile = () => import("@/components/account/profile.vue");

@Component({
    components: {
        UserInfo,
        UserProfile,
        Tab,
    }
})
export default class Account extends Vue {
    private keyword: string = process.env.VUE_APP_KEYWORD;
    private modifyNick: boolean = false;
    private modifyProfile: boolean = false;
    private nick = "";
    private current = "info";
    private userProfile = {};

    private other_job = "";
    private other_platform_str = "";

    private profile_count = 0;

    private sex = ["男", "女"];
    private education = ["小学", "初中", "高中", "大专", "本科", "研究生及以上"];
    private job = ["全职宝妈", "服务员", "售货员", "技工", "钟点工", "客服", "教师", "文员", "医护", "销售", "其他"];
    private work_time = ["0-3小时", "3-6小时", "6-9小时", "9-12小时", "12小时及以上"];
    private work_time_slot = ["0:00-6:00", "6:00-12:00", "12:00-18:00", "18:00-24:00"];
    private amount = ["1000元以下", "1000-3000元", "3000-5000元", "5000-7000元", "7000元以上"];
    private other_platform = ["数据堂", "百度", "京东", "倍赛", "爱数智慧", "无", "其他"];

    private tabList: object[] = [
        {
            value: "info",
            label: "帐号信息",
            key: "1",
        }, {
            value: "profile",
            label: "个人信息",
            key: "2",
        }
    ];

    private created() {
        this.$store.dispatch("initUserInfo");
        this.loadUserProfile();
    }

    private async loadUserProfile() {
        const res = (await getUserProfile()) as any;
        if (res.job && res.job.toString().indexOf("其他") > -1) {
            this.other_job = res.job.toString().replace("其他", "");
            res.job = "其他";
        }

        this.profile_count = 0;
        for (var item in res) {
            this.profile_count++
        }

        this.profile_count = Math.round(this.profile_count / 13 * 100)

        if (res.other_platform) {
            res.other_platform = JSON.parse(res.other_platform);
            res.other_platform.forEach((item, index) => {
                if (item.toString().indexOf("其他") > -1) {
                    this.other_platform_str = item.replace("其他", "");
                    res.other_platform[index] = "其他";
                }
            });
        }

        if (res.work_time_slot) {
            res.work_time_slot = JSON.parse(res.work_time_slot);
        }
        this.$nextTick(() => {
            this.userProfile = res;
        });
    }

    get userInfo() {
        var user = this.$store.state.userInfo;
        return user;
    }

    private changeTag(type) {
        this.current = type;
    }

    private newNick(e) {
        this.nick = e;
    }

    private async handleToChangeNick() {
        if (this.nick && this.nick != "") {
            const res = (await changeNickName(this.nick)) as any;
            if (res.code == 200) {
                const resp: any = await queryCurrent("");
                this.$store.commit("setUser", resp);
                this.$Message.success("修改成功");
                this.modifyNick = false;
            } else {
                this.$Message.success(res.message);
            }
        } else {
            this.$Message.error("昵称不能为空");
        }
    }

    private async handleToUpdateProfile() {
        var data = {...this.userProfile} as any;
        var job = data.job;
        var error = false;
        if (data.work_time_slot) {
            data.work_time_slot = JSON.stringify(data.work_time_slot);
        }
        if (data.other_platform) {
            data.other_platform.forEach((item, index) => {
                if (item == "其他" && (!this.other_platform_str || this.other_platform_str == "")) {
                    this.$Message.error("请输入其他平台");
                    error = true;
                    return;
                }

                if (item == "其他") {
                    data.other_platform[index] = item + this.other_platform_str;
                    return;
                }
            });
            data.other_platform = JSON.stringify(data.other_platform);
        }

        if (job && job.toString().endsWith("其他")) {
            if (!this.other_job || this.other_job == "") {
                this.$Message.error("请输入其他职业");
                error = true;
                return;
            }
            data.job = data.job + this.other_job;
        }

        if (error) {
            return;
        }
        const res = (await updateUserProfile(data)) as any;
        if (res.code == '200') {
            this.loadUserProfile();
            this.modifyProfile = false;
            this.$Message.success("修改成功");
        } else {
            this.$Message.error(res.message);
        }
    }
}
